import { getFathers } from "data/apiConection.js/dataUsers";

export const dashboardRoutes = {
  label: 'Inicio',
  labelDisable: true,
  children: [
    {
      name: 'Inicio',
      active: true,
      icon: 'chart-pie',
      children: [
        {
          name: 'Inicio',
          to: '/',
          active: true
        }
      ]
    }
  ]
};
export const dashboardPadres = {
  label: 'Inicio',
  labelDisable: true,
  children: [
    {
      name: 'Cuotas',
      active: true,
      icon: 'chart-pie',
      children: [
        {
          name: 'Cuotas',
          to: '/estados-cuentas',
          active: true
        }
      ]
    }
  ]
}
export const appRoutes = {
  label: 'Finanazas',
  children: [
    {
      name: 'Sistema de Pagos',
      icon: 'chart-pie',
      active: true,
      children: [

        {
          name: 'Julio',
          to: '/',
          active: true
        }
       
        ,
      ]
    }
  ]
};

export const usuariosRoutes = {
  label: 'Usuarios',
  children: [
    {
      name: 'Usuarios',
      icon: 'user',
      active: true,
      children : [
        {
          name: 'Lista',
          to: '/',
          active: true,
        }
      ]
    }
  ]
};
export const routesByRole = async (role) => {
  switch (role) {
    case 'manager':
      return [
        dashboardRoutes,
        appRoutes,
        usuariosRoutes,
      ];
    case 'admin':
      return [
        dashboardRoutes,
        appRoutes
      ];
    case 'father':
      return [
        dashboardPadres,
      ]
  }
};

const getRoutes = async () => {
  const user = await getFathers();
  const userRole = user?.role || ''; // Fallback si user.role es null o undefined
  console.log(userRole);
  return routesByRole(userRole);
};
export default getRoutes;



